import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

function PdpSharedDetailDealerReference({ item }) {
    const dealerReference = item.dealerReference;
    if (!dealerReference) {
        return null;
    }
    return <span data-tn="pdp-spec-dealer-reference">{dealerReference}</span>;
}

PdpSharedDetailDealerReference.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailDealerReference, {
    item: graphql`
        fragment PdpSharedDetailDealerReference_item on Item {
            dealerReference
        }
    `,
});
